export default __webpack_public_path__ + "static/media/milled.d36fa657.svg";